import o from "./Overlay.vue2.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ r(o, [["__scopeId", "data-v-f21587c6"]]);
export {
  f as default
};
